import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import API from 'services/API';
import {
  getExtraGuestIdentificationDocumentUrl,
  getLeadIdentificationDocumentUrl,
} from 'utils/lead/leadUtils';

export type DeleteIdentificationDocumentArgs = {
  leadUid: string;
  // Absent for the main guest, set for an extra guest.
  extraGuestId?: number | null;
};

const deleteIdentificationDocument = async ({
  leadUid,
  extraGuestId,
}: DeleteIdentificationDocumentArgs) => {
  // Same paths the download links use, with DELETE instead of GET.
  const url =
    extraGuestId == null
      ? getLeadIdentificationDocumentUrl(leadUid)
      : getExtraGuestIdentificationDocumentUrl(leadUid, extraGuestId);

  const response = await API.delete(url!);

  return response.data;
};

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<
    unknown,
    BaseErrorResponse,
    DeleteIdentificationDocumentArgs
  >,
  'mutationFn'
>;

const useDeleteIdentificationDocumentMutation = (
  options?: ReactQueryMutationOptions,
) => {
  return useAppMutation({
    mutationFn: deleteIdentificationDocument,
    ...options,
  });
};

export default useDeleteIdentificationDocumentMutation;
